import {recoleta} from '../typography';

export default {
  gutterBottom: {
    marginBottom: 8
  },
  MuiCssBaseline: {
    '@global': {
      '@font-face': ['Roboto', recoleta, 'Nunito'],
    },
  },
};
